import URIS from 'constants/uris';
import http from 'services/http';

export function getDocumentUploadSettings() {
  return http.get(URIS.ACCOUNT_DOCUMENTS_SETTINGS);
}
